export const ItemVacio = (idPadre) => {
  return {
    id: null,
    idTorneo: idPadre,
    equipo: null,
    organizador: false,
    tituloObtenido: null,
    movimientoDivisional: null,
    posicionFinal: null,
    partidosJugados: null,
    observaciones: '',
  };
};

export const saveItem = (item) => {
  return {
    idTorneo: item.idTorneo,
    idEquipo: item.equipo && item.equipo.id ? item.equipo.id : null,
    organizador: item.organizador || false,
    tituloObtenido: item.tituloObtenido,
    movimientoDivisional: item.movimientoDivisional,
    posicionFinal: item.posicionFinal,
    partidosJugados: item.partidosJugados,
    observaciones: item.observaciones,
  };
};
